import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { DocumentImageOffMIcon } from '@alfalab/icons-glyph/DocumentImageOffMIcon';
import { Text } from './text';
import styles from './index.module.css';
export const Child = ({ children, hasImage, imageLoadingFailed, text, colorText, size }) => {
    if (hasImage)
        return null;
    if (imageLoadingFailed) {
        if (text) {
            return _jsx(Text, { text: text, componentSize: size, colorText: colorText });
        }
        return (_jsx(DocumentImageOffMIcon, { className: styles.iconErrorColor, "data-test-id": 'Image error' }));
    }
    if (text) {
        return _jsx(Text, { text: text, componentSize: size, colorText: colorText });
    }
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return _jsx(React.Fragment, { children: children });
};
